import type { RouteRecordRaw } from "vue-router"
import type { RouteNamedMap } from "vue-router/auto-routes"

export const redirectRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    redirect: "/event/dashboard",
  },
  {
    path: "/event/summary/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/event/[id]/"]["params"]

      return { name: "/event/[id]/", params: { id } }
    },
  },
  {
    path: "/event/edit/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/event/[id]/edit"]["params"]

      return { name: "/event/[id]/edit", params: { id } }
    },
  },
  {
    path: "/event/albums/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/event/[id]/albums"]["params"]

      return { name: "/event/[id]/albums", params: { id } }
    },
  },
  {
    path: "/event/advancedsettings/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/event/[id]/advanced-settings"]["params"]

      return { name: "/event/[id]/advanced-settings", params: { id } }
    },
  },
  {
    path: "/event/managemedia/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/event/[id]/manage-media"]["params"]

      return { name: "/event/[id]/manage-media", params: { id } }
    },
  },
  {
    path: "/event/album/create/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/event/[id]/album/create"]["params"]

      return { name: "/event/[id]/album/create", params: { id } }
    },
  },
  {
    path: "/event/:id/album/edit/:albumId",
    redirect: (to) => {
      const { id, albumId } = to.params as RouteNamedMap["/event/[id]/album/[albumId]/edit"]["params"]

      return { name: "/event/[id]/album/[albumId]/edit", params: { id, albumId } }
    },
  },
  {
    path: "/guest/access/:id/:token",
    redirect: (to) => {
      const { id, token } = to.params as RouteNamedMap["/guest/[id]/access.[token]"]["params"]

      return { name: "/guest/[id]/access.[token]", params: { id, token } }
    },
  },
  {
    path: "/guest/albumaccess/:id/:token/:albumid",
    redirect: (to) => {
      const { id, token, albumid } = to.params as { id: string, token: string, albumid: string }

      return {
        name: "/guest/[id]/access.[token]",
        params: { id, token },
        query: { album: albumid },
      }
    },
  },
  {
    path: "/guest/qr/:id",
    redirect: (to) => {
      const { id } = to.params as { id: string }
      const passcode = to.query.passcode as string

      return {
        name: "/guest/[id]/login",
        params: { id },
        query: passcode ? { passcode } : undefined,
      }
    },
  },
  {
    path: "/guest/login/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/guest/[id]/login"]["params"]

      return { name: "/guest/[id]/login", params: { id } }
    },
  },
  {
    path: "/guest/welcome/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/guest/[id]/welcome"]["params"]

      return { name: "/guest/[id]/welcome", params: { id } }
    },
  },
  {
    path: "/guest/gallery/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/guest/[id]/gallery"]["params"]

      return { name: "/guest/[id]/gallery", params: { id } }
    },
  },
  {
    path: "/guest/remindmelater/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/guest/[id]/reminder"]["params"]

      return { name: "/guest/[id]/reminder", params: { id } }
    },
  },
  {
    path: "/guest/comingsoon/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/guest/[id]/coming-soon"]["params"]

      return { name: "/guest/[id]/coming-soon", params: { id } }
    },
  },
  {
    path: "/guest/guestbook/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/guest/[id]/guest-book"]["params"]

      return { name: "/guest/[id]/guest-book", params: { id } }
    },
  },
  {
    path: "/guest/message/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/guest/[id]/message"]["params"]

      return { name: "/guest/[id]/message", params: { id } }
    },
  },
  {
    path: "/guest/messages/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/guest/[id]/messages"]["params"]

      return { name: "/guest/[id]/messages", params: { id } }
    },
  },
  {
    path: "/guest/unlock/:id/album/:albumId",
    redirect: (to) => {
      const { id, albumId } = to.params as RouteNamedMap["/guest/[id]/album/[albumId]/unlock"]["params"]

      return { name: "/guest/[id]/album/[albumId]/unlock", params: { id, albumId } }
    },
  },
  {
    path: "/event/qrcodegenerator/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/event/[id]/custom-qr"]["params"]

      return { name: "/event/[id]/custom-qr", params: { id } }
    },
  },
  {
    path: "/event/upgrade/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/event/[id]/upgrade/"]["params"]

      return { name: "/event/[id]/upgrade/", params: { id } }
    },
  },
  {
    path: "/event/upgradecontactus/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/event/[id]/upgrade/contact-us"]["params"]

      return { name: "/event/[id]/upgrade/contact-us", params: { id } }
    },
  },
  {
    path: "/event/users/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/event/[id]/users"]["params"]

      return { name: "/event/[id]/users", params: { id } }
    },
  },
  {
    // /HostAccess/AcceptInvitation/1?token=
    path: "/HostAccess/AcceptInvitation/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/event/[id]/accept-invite"]["params"]

      return { name: "/event/[id]/accept-invite", params: { id } }
    },
  },
  {
    path: "/onboard/paymentconfirmation",
    redirect: "/onboard/purchase-confirmation",
  },
  {
    path: "/identity/account/lockout",
    redirect: "lockout",
  },
  {
    path: "/guest/noaccess",
    redirect: "/no-access",
  },
  {
    path: "/identity/account/manage",
    redirect: "/profile",
  },
  {
    path: "/identity/account/login",
    redirect: "/login",
  },
  {
    path: "/template/select/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/event/[id]/customize"]["params"]

      return { name: "/event/[id]/customize", params: { id } }
    },
  },
  {
    path: "/event/:id/template-lite/edit",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/event/[id]/customize"]["params"]

      return { name: "/event/[id]/customize", params: { id } }
    },
  },
  {
    path: "/template/apply",
    redirect: (to) => {
      const eventvaultid = to.query.eventvaultid as string

      return { name: "/event/[id]/template/apply", params: { id: eventvaultid } }
    },
  },
  {
    path: "/template/",
    redirect: "/template/create",
  },
  {
    path: "/Template/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/template/[id]/edit"]["params"]

      return { name: "/template/[id]/edit", params: { id } }
    },
  },
  {
    path: "/Template/ChooseEvent",
    redirect: (to) => {
      const eventTemplateID = to.query.eventTemplateID as string

      return { name: "/template/[id]/assign", params: { id: eventTemplateID } }
    },
  },
  {
    path: "/event/:id/guests",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/event/[id]/guest-list"]["params"]

      return { name: "/event/[id]/guest-list", params: { id } }
    },
  },
  {
    path: "/event/slideshow/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/event/[id]/slideshow/"]["params"]

      return { name: "/event/[id]/slideshow/", params: { id } }
    },
  },
  {
    path: "/event/print/:id",
    redirect: (to) => {
      const { id } = to.params as RouteNamedMap["/event/[id]/print"]["params"]

      return { name: "/event/[id]/print", params: { id } }
    },
  },
]

export const externalRedirects = [
  "/onboard/register",
  "/onboard/create",
  "/event/zipdownload",
  "/guest/pix",
]
